import { useState } from "react";
import { toast } from "react-toastify";
import { logoutAllDevices as logoutAllDevicesAPI } from "../api";

export const useLogoutAllDevices = (userId, callbacks = {}) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { onSuccess, onError } = callbacks;

  const handleLogout = async () => {
    if (!userId) {
      const errorMsg = "ID do usuário não encontrado para realizar o logout.";
      toast.error(errorMsg);
      setError(errorMsg);
      if (onError) onError(new Error(errorMsg));
      return;
    }

    setLoading(true);
    setError("");

    try {
      await logoutAllDevicesAPI(userId);
      setError("");
      setShowModal(false);
      toast.success("Usuário deslogado de todos os dispositivos com sucesso!");
      if (onSuccess) onSuccess();
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        "Erro ao deslogar usuário de todos os dispositivos.";
      setError(errorMessage);
      if (onError) onError(err);
    } finally {
      setLoading(false);
    }
  };

  const openModal = () => {
    if (!userId) {
      toast.error("ID do usuário não encontrado para abrir o modal de logout.");
      return;
    }
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setError("");
  };

  return {
    showModal,
    setShowModal,
    openModal,
    closeModal,
    loading,
    error,
    handleLogout,
  };
};
